// Loaders
import Loader from "./components/Layout/Loader.vue";

// Panels
import Panel from "./components/UIComponents/Panel/Panel.vue";
import PanelHeading from "./components/UIComponents/Panel/PanelHeading.vue";
import PanelBody from "./components/UIComponents/Panel/PanelBody.vue";
import PanelFooter from "./components/UIComponents/Panel/PanelFooter.vue";
import PanelTable from "./components/UIComponents/Panel/PanelTable.vue";

// Forms
import FormGroupInput from "./components/UIComponents/Forms/FormGroupInput.vue";
import FormGroupCpf from "./components/UIComponents/Forms/FormGroupCpf.vue";
import FormGroupCnpj from "./components/UIComponents/Forms/FormGroupCnpj.vue";
import FormGroupSelect from "./components/UIComponents/Forms/FormGroupSelect.vue";
import Checkbox from "./components/UIComponents/Forms/Checkbox.vue";
import WoodysCheckbox from "./components/UIComponents/Forms/WoodysCheckbox.vue";
import CKEditorClassic from "./components/UIComponents/Forms/CKEditorClassic.vue";
import FormValidator from "./components/UIComponents/Forms/FormValidator.vue";
import DropzoneUpload from "./components/UIComponents/Forms/DropzoneUpload.vue";
import ErrorMessage from "./components/UIComponents/Forms/ErrorMessage.vue";
import FormGroupSelectGroup from "./components/UIComponents/Forms/FormGroupSelectGroup.vue";
import FormGroupSearchSelect from "./components/UIComponents/Forms/FormGroupSearchSelect.vue";
import FormGroupSearchSelectMultiple from "./components/UIComponents/Forms/FormGroupSearchSelectMultiple.vue";
import DropzoneUploadCloud from "./components/UIComponents/Forms/DropzoneUploadCloud.vue";
import Radio from "./components/UIComponents/Forms/Radio.vue";
import FormGroupDateTimePicker from "./components/UIComponents/Forms/FormGroupDateTimePicker.vue";
import FormGroupInputGroup from "./components/UIComponents/Forms/FormGroupInputGroup.vue";
import FormGroupBootstrapToggle from "./components/UIComponents/Forms/FormGroupBootstrapToggle.vue";
import FormGroupSearchSelectGroup from "./components/UIComponents/Forms/FormGroupSearchSelectGroup.vue";
import FormGroupTextArea from "./components/UIComponents/Forms/FormGroupTextArea";

// Buttons
import FormButton from "./components/UIComponents/Buttons/FormButton.vue";
import ButtonLink from "./components/UIComponents/Buttons/ButtonLink.vue";

// Buttons
import Alert from "./components/UIComponents/Messages/Alert.vue";
import ButtonIntegradon from "./components/UIComponents/Buttons/ButtonIntegradon.vue";

// Dropdowns
import ListDivider from "./components/UIComponents/Dropdown/ListDivider.vue";

// Collapse
import Accordion from "./components/UIComponents/Collapse/Accordion.vue";
import CollapseTitle from "./components/UIComponents/Collapse/CollapseTitle.vue";
import CollapseHeader from "./components/UIComponents/Collapse/CollapseHeader.vue";
import CollapseContent from "./components/UIComponents/Collapse/CollapseContent.vue";
import Collapse from "./components/UIComponents/Collapse/Collapse.vue";

// Crm
import Nascimento from "./components/UIComponents/Crm/Nascimento.vue";
import Cpf from "./components/UIComponents/Crm/Cpf.vue";
import Cep from "./components/UIComponents/Crm/Cep.vue";
import Logradouro from "./components/UIComponents/Crm/Logradouro.vue";
import Bairro from "./components/UIComponents/Crm/Bairro.vue";
import Cidade from "./components/UIComponents/Crm/Cidade.vue";
import Estado from "./components/UIComponents/Crm/Estado.vue";
import Sexo from "./components/UIComponents/Crm/Sexo.vue";
import Email from "./components/UIComponents/Crm/Email.vue";
import Telefone from "./components/UIComponents/Crm/Telefone.vue";
import TextoMedioMinimoPalavras from "./components/UIComponents/Crm/TextoMedioMinimoPalavras.vue";
import TextoMedioMinimoLetras from "./components/UIComponents/Crm/TextoMedioMinimoLetras.vue";
import TextoCurto from "./components/UIComponents/Crm/TextoCurto.vue";
import Nacionalidade from "./components/UIComponents/Crm/Nacionalidade.vue";
import TelefoneConjuge from "./components/UIComponents/Crm/TelefoneConjuge.vue";
import EstadoCivil from "./components/UIComponents/Crm/EstadoCivil.vue";
import NomeConjuge from "./components/UIComponents/Crm/NomeConjuge.vue";
import EmailConjuge from "./components/UIComponents/Crm/EmailConjuge.vue";
import CpfConjuge from "./components/UIComponents/Crm/CpfConjuge.vue";
import NascimentoConjuge from "./components/UIComponents/Crm/NascimentoConjuge.vue";
import RecebimentoBoleto from "./components/UIComponents/Crm/RecebimentoBoleto.vue";
import Default from "./components/UIComponents/Crm/Default.vue";
import ReceberToken from "./components/UIComponents/Crm/ReceberToken.vue";
import NecessidadeEspecial from "./components/UIComponents/Crm/NecessidadeEspecial.vue";
import Optin from "./components/UIComponents/Crm/Optin.vue";

// Modal
import Modal from "./components/UIComponents/Modal/Modal.vue";
import ModalHeader from "./components/UIComponents/Modal/ModalHeader.vue";
import ModalBody from "./components/UIComponents/Modal/ModalBody.vue";
import ModalFooter from "./components/UIComponents/Modal/ModalFooter.vue";

// Table
import DataTable from "./components/UIComponents/Tables/DataTable";
import ThSortField from "./components/UIComponents/Tables/ThSortField";
import ThNoSortField from "./components/UIComponents/Tables/ThNoSortField";

// Timeline
import Timeline from "./components/UIComponents/Timeline/Timeline.vue";
import TimelineItem from "./components/UIComponents/Timeline/TimelineItem.vue";
import TimelineBadge from "./components/UIComponents/Timeline/TimelineBadge.vue";
import TimelinePanel from "./components/UIComponents/Timeline/TimelinePanel.vue";
import TimelineHeading from "./components/UIComponents/Timeline/TimelineHeading.vue";
import TimelineBody from "./components/UIComponents/Timeline/TimelineBody.vue";
import TimelineFooter from "./components/UIComponents/Timeline/TimelineFooter.vue";
import TimelineLead from "./components/UIComponents/Timeline/TimelineLead.vue";

// BsWizard
import BsWizard from "./components/UIComponents/BsWizard/BsWizard.vue";
import BsWizardStep from "./components/UIComponents/BsWizard/BsWizardStep.vue";
import BsWizardStepnum from "./components/UIComponents/BsWizard/BsWizardStepnum.vue";
import BsWizardInfo from "./components/UIComponents/BsWizard/BsWizardInfo.vue";
import BsWizardDot from "./components/UIComponents/BsWizard/BsWizardDot.vue";

// Animation
import TransitionGroupList from "./components/UIComponents/Animation/TransitionGroupList.vue";

// Protocolo
import ProtocoloDefault from "./components/UIComponents/Protocolo/Campos/Default.vue";
import ProtocoloCurso from "./components/UIComponents/Protocolo/Campos/Curso.vue";
import ProtocoloBanco from "./components/UIComponents/Protocolo/Campos/Banco.vue";
import ProtocoloTipoConta from "./components/UIComponents/Protocolo/Campos/TipoConta.vue";
import ProtocoloTodosCurso from "./components/UIComponents/Protocolo/Campos/TodosCurso.vue";
import ProtocoloTodosCursosFaculdade from "./components/UIComponents/Protocolo/Campos/TodosCursosFaculdade";
import ProtocoloTodosCursoGraduacao from "./components/UIComponents/Protocolo/Campos/TodosCursoGraduacao.vue";
import ProtocoloCursosPos from "./components/UIComponents/Protocolo/Campos/CursosPos.vue";
import ProtocoloPeriodo from "./components/UIComponents/Protocolo/Campos/Periodo.vue";
import ProtocoloTextArea from "./components/UIComponents/Protocolo/Campos/TextArea.vue";
import ProtocoloTextAreaParcelamento from "./components/UIComponents/Protocolo/Campos/TextAreaParcelamento.vue";
import ProtocoloAnexo from "./components/UIComponents/Protocolo/Campos/Anexo.vue";
import ProtocoloProfessor from "./components/UIComponents/Protocolo/Campos/Professor.vue";
import ProtocoloAnoReferencia from "./components/UIComponents/Protocolo/Campos/AnoReferencia.vue";
import ProtocoloTextCurto from "./components/UIComponents/Protocolo/Campos/TextCurto.vue";
import ProtocoloCepEmpresa from "./components/UIComponents/Protocolo/Campos/CepEmpresa.vue";
import ProtocoloEmail from "./components/UIComponents/Protocolo/Campos/Email.vue";
import ProtocoloTelefone from "./components/UIComponents/Protocolo/Campos/Telefone.vue";
import ProtocoloCpf from "./components/UIComponents/Protocolo/Campos/Cpf.vue";
import ProtocoloCnpj from "./components/UIComponents/Protocolo/Campos/Cnpj.vue";
import ProtocoloTcc from "./components/UIComponents/Protocolo/Campos/Tcc.vue";
import ProtocoloDuplaTcc from "./components/UIComponents/Protocolo/Campos/DuplaTcc";
import ProtocoloDate from "./components/UIComponents/Protocolo/Campos/Date.vue";
import ProtocoloLocalEstagio from "./components/UIComponents/Protocolo/Campos/LocalEstagio.vue";
import ProtocoloTipoPessoa from "./components/UIComponents/Protocolo/Campos/TipoPessoa.vue";
import ProtocoloTodosProfessores from "./components/UIComponents/Protocolo/Campos/TodosProfessores.vue";
import ProtocoloNumberCurto from "./components/UIComponents/Protocolo/Campos/NumberCurto.vue";
import ProtocoloBolsista from "./components/UIComponents/Protocolo/Campos/Bolsista.vue";
import ProtocoloDisciplina from "./components/UIComponents/Protocolo/Campos/Disciplina.vue";
import ProtocoloDisciplinaReprovado from "./components/UIComponents/Protocolo/Campos/DisciplinaReprovado.vue";
import ProtocoloDisciplinaMultipla from "./components/UIComponents/Protocolo/Campos/DisciplinaMultipla.vue";
import ProtocoloTurnoColegio from "./components/UIComponents/Protocolo/Campos/TurnoColegio.vue";
import ProtocoloDisciplinaAtiva from "./components/UIComponents/Protocolo/Campos/DisciplinaAtiva.vue";
import ProtocoloDeclaracaoPercentualCursado from "./components/UIComponents/Protocolo/Campos/DeclaracaoPercentualCursado.vue";
import ProtocoloTurmaColegio from "./components/UIComponents/Protocolo/Campos/TurmaColegio.vue";
import ProtocoloSerieColegio from "./components/UIComponents/Protocolo/Campos/SerieColegio.vue";
import ProtocoloPeriodoMultiplo from "./components/UIComponents/Protocolo/Campos/PeriodoMultiplo.vue";
import ProtocoloMotivo from "./components/UIComponents/Protocolo/Campos/Motivo.vue";
import PercentualSolicitado from "./components/UIComponents/Protocolo/Campos/PercentualSolicitado.vue";
import PeriodoSolicitado from "./components/UIComponents/Protocolo/Campos/PeriodoSolicitado.vue";
import FormaPagamentoParcelasAmortizacao from "./components/UIComponents/Protocolo/Campos/FormaPagamentoParcelasAmortizacao.vue";
import CursoModalidade from "./components/UIComponents/Protocolo/Campos/CursoModalidade.vue";
import ProtocoloModalidadeEnsino from "./components/UIComponents/Protocolo/Campos/modalidadeEnsino.vue";
import ProtocoloDataAtestado from "./components/UIComponents/Protocolo/Campos/DataAtestado.vue";
import ProtocoloDiasAtestado from "./components/UIComponents/Protocolo/Campos/DiasAtestado.vue";
import DataFinalAtestado from "./components/UIComponents/Protocolo/Campos/DataFinalAtestado.vue";
import ProtocoloCidAtestado from "./components/UIComponents/Protocolo/Campos/CidAtestado.vue";
import DisciplinasAtivasMultiplas from "./components/UIComponents/Protocolo/Campos/DisciplinasAtivasMultiplas.vue";

// Protocolo View
import ViewProtocoloDefault from "./components/UIComponents/Protocolo/View/Default.vue";
import ViewProtocoloCurso from "./components/UIComponents/Protocolo/View/Curso.vue";
import ViewProtocoloBanco from "./components/UIComponents/Protocolo/View/Banco.vue";
import ViewProtocoloTipoConta from "./components/UIComponents/Protocolo/View/TipoConta.vue";
import ViewProtocoloTodosCurso from "./components/UIComponents/Protocolo/View/TodosCurso.vue";
import ViewProtocoloTodosCursoGraduacao from "./components/UIComponents/Protocolo/View/TodosCursoGraduacao.vue";
import ViewProtocoloPeriodo from "./components/UIComponents/Protocolo/View/Periodo.vue";
import ViewProtocoloTextArea from "./components/UIComponents/Protocolo/View/TextArea.vue";
import ViewProtocoloTextAreaParcelamento from "./components/UIComponents/Protocolo/View/TextAreaParcelamento.vue";
import ViewProtocoloProfessor from "./components/UIComponents/Protocolo/View/Professor.vue";
import ViewProtocoloAnoReferencia from "./components/UIComponents/Protocolo/View/AnoReferencia.vue";
import ViewProtocoloTextCurto from "./components/UIComponents/Protocolo/View/TextCurto.vue";
import ViewProtocoloCepEmpresa from "./components/UIComponents/Protocolo/View/CepEmpresa.vue";
import ViewProtocoloEmail from "./components/UIComponents/Protocolo/View/Email.vue";
import ViewProtocoloTelefone from "./components/UIComponents/Protocolo/View/Telefone.vue";
import ViewProtocoloCpf from "./components/UIComponents/Protocolo/View/Cpf.vue";
import ViewProtocoloCnpj from "./components/UIComponents/Protocolo/View/Cnpj.vue";
import ViewProtocoloTcc from "./components/UIComponents/Protocolo/View/Tcc.vue";
import ViewProtocoloDuplaTcc from "./components/UIComponents/Protocolo/View/DuplaTcc.vue";
import ViewProtocoloDate from "./components/UIComponents/Protocolo/View/Date.vue";
import ViewProtocoloLocalEstagio from "./components/UIComponents/Protocolo/View/LocalEstagio.vue";
import ViewProtocoloTipoPessoa from "./components/UIComponents/Protocolo/View/TipoPessoa.vue";
import ViewProtocoloTodosProfessores from "./components/UIComponents/Protocolo/View/TodosProfessores.vue";
import ViewProtocoloNumberCurto from "./components/UIComponents/Protocolo/View/NumberCurto.vue";
import ViewProtocoloBolsista from "./components/UIComponents/Protocolo/View/Bolsista.vue";
import ViewProtocoloDisciplina from "./components/UIComponents/Protocolo/View/Disciplina.vue";
import ViewProtocoloDisciplinaReprovado from "./components/UIComponents/Protocolo/View/DisciplinaReprovado.vue";
import ViewProtocoloDisciplinaMultipla from "./components/UIComponents/Protocolo/View/DisciplinaMultipla.vue";
import ViewProtocoloTurnoColegio from "./components/UIComponents/Protocolo/View/TurnoColegio.vue";
import ViewProtocoloDisciplinaAtiva from "./components/UIComponents/Protocolo/View/DisciplinaAtiva.vue";
import ViewProtocoloDeclaracaoPercentualCursado from "./components/UIComponents/Protocolo/View/DeclaracaoPercentualCursado.vue";
import ViewProtocoloTurmaColegio from "./components/UIComponents/Protocolo/View/TurmaColegio.vue";
import ViewProtocoloSerieColegio from "./components/UIComponents/Protocolo/View/SerieColegio.vue";
import ViewProtocoloPeriodoMultiplo from "./components/UIComponents/Protocolo/View/PeriodoMultiplo.vue";
import ViewProtocoloMotivo from "./components/UIComponents/Protocolo/View/Motivo.vue";
import ViewModalidadeEnsino from "./components/UIComponents/Protocolo/View/ModalidadeEnsino.vue";

const GlobalComponents = {
  install(Vue) {
    Vue.component(Panel.name, Panel);
    Vue.component(PanelBody.name, PanelBody);
    Vue.component(PanelHeading.name, PanelHeading);
    Vue.component(PanelFooter.name, PanelFooter);
    Vue.component(FormGroupInput.name, FormGroupInput);
    Vue.component(FormGroupCpf.name, FormGroupCpf);
    Vue.component(FormGroupCnpj.name, FormGroupCnpj);
    Vue.component(FormGroupSelect.name, FormGroupSelect);
    Vue.component(FormGroupSearchSelect.name, FormGroupSearchSelect);
    Vue.component(
      FormGroupSearchSelectMultiple.name,
      FormGroupSearchSelectMultiple
    );
    Vue.component(FormGroupTextArea.name, FormGroupTextArea);
    Vue.component(Checkbox.name, Checkbox);
    Vue.component(WoodysCheckbox.name, WoodysCheckbox);
    Vue.component(DropzoneUpload.name, DropzoneUpload);
    Vue.component(DropzoneUploadCloud.name, DropzoneUploadCloud);
    Vue.component(Radio.name, Radio);
    Vue.component(FormGroupDateTimePicker.name, FormGroupDateTimePicker);
    Vue.component(ErrorMessage.name, ErrorMessage);
    Vue.component(FormValidator.name, FormValidator);
    Vue.component(FormButton.name, FormButton);
    Vue.component(ButtonLink.name, ButtonLink);
    Vue.component(Nascimento.name, Nascimento);
    Vue.component(Cpf.name, Cpf);
    Vue.component(Cep.name, Cep);
    Vue.component(Logradouro.name, Logradouro);
    Vue.component(Bairro.name, Bairro);
    Vue.component(Cidade.name, Cidade);
    Vue.component(Estado.name, Estado);
    Vue.component(Sexo.name, Sexo);
    Vue.component(Email.name, Email);
    Vue.component(Telefone.name, Telefone);
    Vue.component(TelefoneConjuge.name, TelefoneConjuge);
    Vue.component(NascimentoConjuge.name, NascimentoConjuge);
    Vue.component(NecessidadeEspecial.name, NecessidadeEspecial);
    Vue.component(Optin.name, Optin);
    Vue.component(CpfConjuge.name, CpfConjuge);
    Vue.component(EmailConjuge.name, EmailConjuge);
    Vue.component(TextoMedioMinimoPalavras.name, TextoMedioMinimoPalavras);
    Vue.component(TextoCurto.name, TextoCurto);
    Vue.component(Nacionalidade.name, Nacionalidade);
    Vue.component(EstadoCivil.name, EstadoCivil);
    Vue.component(NomeConjuge.name, NomeConjuge);
    Vue.component(RecebimentoBoleto.name, RecebimentoBoleto);
    Vue.component(ListDivider.name, ListDivider);
    Vue.component(CollapseTitle.name, CollapseTitle);
    Vue.component(CollapseHeader.name, CollapseHeader);
    Vue.component(CollapseContent.name, CollapseContent);
    Vue.component(Accordion.name, Accordion);
    Vue.component(Collapse.name, Collapse);
    Vue.component(Alert.name, Alert);
    Vue.component(Default.name, Default);
    Vue.component(PanelTable.name, PanelTable);
    Vue.component(Modal.name, Modal);
    Vue.component(ModalHeader.name, ModalHeader);
    Vue.component(ModalBody.name, ModalBody);
    Vue.component(ModalFooter.name, ModalFooter);
    Vue.component(TextoMedioMinimoLetras.name, TextoMedioMinimoLetras);
    Vue.component(DataTable.name, DataTable);
    Vue.component(ThSortField.name, ThSortField);
    Vue.component(CKEditorClassic.name, CKEditorClassic);
    Vue.component(ThNoSortField.name, ThNoSortField);
    Vue.component(ButtonIntegradon.name, ButtonIntegradon);
    Vue.component(Timeline.name, Timeline);
    Vue.component(TimelineItem.name, TimelineItem);
    Vue.component(TimelineBadge.name, TimelineBadge);
    Vue.component(TimelinePanel.name, TimelinePanel);
    Vue.component(TimelineHeading.name, TimelineHeading);
    Vue.component(TimelineBody.name, TimelineBody);
    Vue.component(TimelineFooter.name, TimelineFooter);
    Vue.component(TimelineLead.name, TimelineLead);
    Vue.component(BsWizard.name, BsWizard);
    Vue.component(BsWizardStep.name, BsWizardStep);
    Vue.component(BsWizardStepnum.name, BsWizardStepnum);
    Vue.component(BsWizardInfo.name, BsWizardInfo);
    Vue.component(BsWizardDot.name, BsWizardDot);
    Vue.component(FormGroupSelectGroup.name, FormGroupSelectGroup);
    Vue.component(TransitionGroupList.name, TransitionGroupList);
    Vue.component(ProtocoloDefault.name, ProtocoloDefault);
    Vue.component(ProtocoloCurso.name, ProtocoloCurso);
    Vue.component(ProtocoloBanco.name, ProtocoloBanco);
    Vue.component(ProtocoloTipoConta.name, ProtocoloTipoConta);
    Vue.component(ProtocoloTodosCurso.name, ProtocoloTodosCurso);
    Vue.component(ProtocoloTodosCursosFaculdade.name, ProtocoloTodosCursosFaculdade);
    Vue.component(
      ProtocoloTodosCursoGraduacao.name,
      ProtocoloTodosCursoGraduacao
    );
    Vue.component(ProtocoloCursosPos.name, ProtocoloCursosPos);
    Vue.component(ProtocoloPeriodo.name, ProtocoloPeriodo);
    Vue.component(ProtocoloTextArea.name, ProtocoloTextArea);
    Vue.component(
      ProtocoloTextAreaParcelamento.name,
      ProtocoloTextAreaParcelamento
    );
    Vue.component(ProtocoloAnexo.name, ProtocoloAnexo);
    Vue.component(ProtocoloProfessor.name, ProtocoloProfessor);
    Vue.component(ProtocoloAnoReferencia.name, ProtocoloAnoReferencia);
    Vue.component(ProtocoloTextCurto.name, ProtocoloTextCurto);
    Vue.component(ProtocoloCepEmpresa.name, ProtocoloCepEmpresa);
    Vue.component(ProtocoloEmail.name, ProtocoloEmail);
    Vue.component(ProtocoloTelefone.name, ProtocoloTelefone);
    Vue.component(ProtocoloCpf.name, ProtocoloCpf);
    Vue.component(ProtocoloCnpj.name, ProtocoloCnpj);
    Vue.component(ProtocoloTcc.name, ProtocoloTcc);
    Vue.component(ProtocoloDuplaTcc.name, ProtocoloDuplaTcc);
    Vue.component(ProtocoloDate.name, ProtocoloDate);
    Vue.component(ProtocoloLocalEstagio.name, ProtocoloLocalEstagio);
    Vue.component(ProtocoloTipoPessoa.name, ProtocoloTipoPessoa);
    Vue.component(ProtocoloTodosProfessores.name, ProtocoloTodosProfessores);
    Vue.component(ProtocoloNumberCurto.name, ProtocoloNumberCurto);
    Vue.component(ProtocoloBolsista.name, ProtocoloBolsista);
    Vue.component(ProtocoloDisciplina.name, ProtocoloDisciplina);
    Vue.component(
      ProtocoloDisciplinaReprovado.name,
      ProtocoloDisciplinaReprovado
    );
    Vue.component(
      ProtocoloDisciplinaMultipla.name,
      ProtocoloDisciplinaMultipla
    );
    Vue.component(ProtocoloTurnoColegio.name, ProtocoloTurnoColegio);
    Vue.component(ProtocoloDisciplinaAtiva.name, ProtocoloDisciplinaAtiva);
    Vue.component(
      ProtocoloDeclaracaoPercentualCursado.name,
      ProtocoloDeclaracaoPercentualCursado
    );
    Vue.component(ProtocoloTurmaColegio.name, ProtocoloTurmaColegio);
    Vue.component(ProtocoloSerieColegio.name, ProtocoloSerieColegio);
    Vue.component(ProtocoloPeriodoMultiplo.name, ProtocoloPeriodoMultiplo);
    Vue.component(ProtocoloMotivo.name, ProtocoloMotivo);
    Vue.component(ProtocoloModalidadeEnsino.name, ProtocoloModalidadeEnsino);
    Vue.component(PercentualSolicitado.name, PercentualSolicitado);
    Vue.component(PeriodoSolicitado.name, PeriodoSolicitado);
    Vue.component(
      FormaPagamentoParcelasAmortizacao.name,
      FormaPagamentoParcelasAmortizacao
    );
    Vue.component(CursoModalidade.name, CursoModalidade);
    Vue.component(Loader.name, Loader);
    Vue.component(FormGroupInputGroup.name, FormGroupInputGroup);
    Vue.component(FormGroupBootstrapToggle.name, FormGroupBootstrapToggle);
    Vue.component(FormGroupSearchSelectGroup.name, FormGroupSearchSelectGroup);
    Vue.component(ViewProtocoloDefault.name, ViewProtocoloDefault);
    Vue.component(ViewProtocoloCurso.name, ViewProtocoloCurso);
    Vue.component(ViewProtocoloBanco.name, ViewProtocoloBanco);
    Vue.component(ViewProtocoloTipoConta.name, ViewProtocoloTipoConta);
    Vue.component(ViewProtocoloTodosCurso.name, ViewProtocoloTodosCurso);
    Vue.component(
      ViewProtocoloTodosCursoGraduacao.name,
      ViewProtocoloTodosCursoGraduacao
    );
    Vue.component(ViewProtocoloPeriodo.name, ViewProtocoloPeriodo);
    Vue.component(ViewProtocoloTextArea.name, ViewProtocoloTextArea);
    Vue.component(
      ViewProtocoloTextAreaParcelamento.name,
      ViewProtocoloTextAreaParcelamento
    );
    Vue.component(ViewProtocoloProfessor.name, ViewProtocoloProfessor);
    Vue.component(ViewProtocoloAnoReferencia.name, ViewProtocoloAnoReferencia);
    Vue.component(ViewProtocoloTextCurto.name, ViewProtocoloTextCurto);
    Vue.component(ViewProtocoloCepEmpresa.name, ViewProtocoloCepEmpresa);
    Vue.component(ViewProtocoloEmail.name, ViewProtocoloEmail);
    Vue.component(ViewProtocoloTelefone.name, ViewProtocoloTelefone);
    Vue.component(ViewProtocoloCpf.name, ViewProtocoloCpf);
    Vue.component(ViewProtocoloCnpj.name, ViewProtocoloCnpj);
    Vue.component(ViewProtocoloTcc.name, ViewProtocoloTcc);
    Vue.component(ViewProtocoloDuplaTcc.name, ViewProtocoloDuplaTcc);
    Vue.component(ViewProtocoloDate.name, ViewProtocoloDate);
    Vue.component(ViewProtocoloLocalEstagio.name, ViewProtocoloLocalEstagio);
    Vue.component(ViewProtocoloTipoPessoa.name, ViewProtocoloTipoPessoa);
    Vue.component(
      ViewProtocoloTodosProfessores.name,
      ViewProtocoloTodosProfessores
    );
    Vue.component(ViewProtocoloNumberCurto.name, ViewProtocoloNumberCurto);
    Vue.component(ViewProtocoloBolsista.name, ViewProtocoloBolsista);
    Vue.component(ViewProtocoloDisciplina.name, ViewProtocoloDisciplina);
    Vue.component(
      ViewProtocoloDisciplinaReprovado.name,
      ViewProtocoloDisciplinaReprovado
    );
    Vue.component(
      ViewProtocoloDisciplinaMultipla.name,
      ViewProtocoloDisciplinaMultipla
    );
    Vue.component(ViewProtocoloTurnoColegio.name, ViewProtocoloTurnoColegio);
    Vue.component(
      ViewProtocoloDisciplinaAtiva.name,
      ViewProtocoloDisciplinaAtiva
    );
    Vue.component(
      ViewProtocoloDeclaracaoPercentualCursado.name,
      ViewProtocoloDeclaracaoPercentualCursado
    );
    Vue.component(ViewProtocoloTurmaColegio.name, ViewProtocoloTurmaColegio);
    Vue.component(ViewProtocoloSerieColegio.name, ViewProtocoloSerieColegio);
    Vue.component(
      ViewProtocoloPeriodoMultiplo.name,
      ViewProtocoloPeriodoMultiplo
    );
    Vue.component(ViewProtocoloMotivo.name, ViewProtocoloMotivo);
    Vue.component(ViewModalidadeEnsino.name, ViewModalidadeEnsino);
    Vue.component(ReceberToken.name, ReceberToken);
    Vue.component(ProtocoloDataAtestado.name, ProtocoloDataAtestado);
    Vue.component(ProtocoloDiasAtestado.name, ProtocoloDiasAtestado);
    Vue.component(DataFinalAtestado.name, DataFinalAtestado);
    Vue.component(ProtocoloCidAtestado.name, ProtocoloCidAtestado);
    Vue.component(DisciplinasAtivasMultiplas.name, DisciplinasAtivasMultiplas);
  }
};

export default GlobalComponents;



// WEBPACK FOOTER //
// ./src/globalComponents.js